export default {
    state() {
        return {
            email: {
                configurationType: {
                    SMTP: 'smtp',
                    OAUTH: 'oauth',
                    APP_PASSWORD: 'app_password',

                    toArray() {
                        return [this.SMTP, this.OAUTH, this.APP_PASSWORD];
                    }
                }
            }
        };
    },
    getters: {
        emailConfigurationTypes(state) {
            return state.email.configurationType;
        }
    }
}
